import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
const NoItemMessage = ({ message }) => (_jsx("li", Object.assign({ className: 'no-item-message disabled pointer-events-none' }, { children: _jsx("a", Object.assign({ role: 'button', href: 'any' }, { children: _jsx("i", { children: message }) })) })));
export default NoItemMessage;
